import { createStore } from 'vuex'

const slugs = {
  'us-dollar': 'USD',
  'pound-sterling': 'GBP',
  'swiss-franc': 'CHF',
  'swedish-kroner': 'SEK',
  'norwegian-krone': 'NOK',
  'danish-kroner': 'DKK',
  'djibouti-franc': 'DJF',
  'indian-rupee': 'INR',
  'kenyan-shilling': 'KES',
  'japanese-yen': 'JPY',
  'canadian-dollar': 'CAD',
  'australian-dollar': 'AUD',
  'saudi-riyal': 'SAR',
  'uae-dirham': 'AED',
  euro: 'EUR',
  'south-african-rand': 'ZAR',
  'chinese-yuan': 'CNY',
  'kuwaiti-dinar': 'KWD'
}

export default createStore({
  state: {
    top: [
      'USD',
      'GBP',
      'EUR',
      'CNY'
    ],
    pairs: [
      'usdetb',
      'gbpetb',
      'euretb',
      'cnyetb',
      'chfetb',
      'seketb',
      'noketb',
      'dkketb',
      'djfetb',
      'inretb',
      'kesetb',
      'jpyetb',
      'cadetb',
      'audetb',
      'saretb',
      'aedetb',
      'zaretb',
      'kwdetb'
    ],
    tickers: {},
    infos: {},
    metas: {
      USD: {
        name: 'US Dollar',
        slug: 'us-dollar',
        symbol: 'usd',
        urls: {
          website: '#'
        },
        about: '',
        logo: require('../assets/img/usd.svg')
      },
      GBP: {
        name: 'Pound Sterling',
        slug: 'pound-sterling',
        symbol: 'gbp',
        urls: {
          website: '#'
        },
        about: '',
        logo: require('../assets/img/gbp.svg')
      },
      CHF: {
        name: 'Swiss Franc',
        slug: 'swiss-franc',
        symbol: 'chf',
        urls: {
          website: '#'
        },
        about: '',
        logo: require('../assets/img/chf.svg')
      },
      SEK: {
        name: 'Swedish Kroner',
        slug: 'swedish-kroner',
        symbol: 'sek',
        urls: {
          website: '#'
        },
        about: '',
        logo: require('../assets/img/sek.svg')
      },
      NOK: {
        name: 'Norwegian Krone',
        slug: 'norwegian-krone',
        symbol: 'nok',
        urls: {
          website: '#'
        },
        about: '',
        logo: require('../assets/img/nok.svg')
      },
      DKK: {
        name: 'Danish Kroner',
        slug: 'danish-kroner',
        symbol: 'nok',
        urls: {
          website: '#'
        },
        about: '',
        logo: require('../assets/img/dkk.svg')
      },
      DJF: {
        name: 'Djibouti Franc',
        slug: 'djibouti-franc',
        symbol: 'djf',
        urls: {
          website: '#'
        },
        about: '',
        logo: require('../assets/img/djf.svg')
      },
      INR: {
        name: 'Indian Rupee',
        slug: 'indian-rupee',
        symbol: 'inr',
        urls: {
          website: '#'
        },
        about: '',
        logo: require('../assets/img/inr.svg')
      },
      KES: {
        name: 'Kenyan Shilling',
        slug: 'kenyan-shilling',
        symbol: 'kes',
        urls: {
          website: '#'
        },
        about: '',
        logo: require('../assets/img/kes.svg')
      },
      JPY: {
        name: 'Japanese Yen',
        slug: 'japanese-yen',
        symbol: 'jpy',
        urls: {
          website: '#'
        },
        about: '',
        logo: require('../assets/img/jpy.svg')
      },
      CAD: {
        name: 'Canadian Dollar',
        slug: 'canadian-dollar',
        symbol: 'cad',
        urls: {
          website: '#'
        },
        about: '',
        logo: require('../assets/img/cad.svg')
      },
      AUD: {
        name: 'Australian Dollar',
        slug: 'australian-dollar',
        symbol: 'aud',
        urls: {
          website: '#'
        },
        about: '',
        logo: require('../assets/img/aud.svg')
      },
      SAR: {
        name: 'Saudi Riyal',
        slug: 'saudi-riyal',
        symbol: 'sar',
        urls: {
          website: '#'
        },
        about: '',
        logo: require('../assets/img/sar.svg')
      },
      AED: {
        name: 'UAE Dirham',
        slug: 'uae-dirham',
        symbol: 'aed',
        urls: {
          website: '#'
        },
        about: '',
        logo: require('../assets/img/aed.svg')
      },
      EUR: {
        name: 'Euro',
        slug: 'euro',
        symbol: 'eur',
        urls: {
          website: '#'
        },
        about: '',
        logo: require('../assets/img/eur.svg')
      },
      ZAR: {
        name: 'South African Rand',
        slug: 'south-african-rand',
        symbol: 'zar',
        urls: {
          website: '#'
        },
        about: '',
        logo: require('../assets/img/zar.svg')
      },
      CNY: {
        name: 'Chinese Yuan',
        slug: 'chinese-yuan',
        symbol: 'cny',
        urls: {
          website: '#'
        },
        about: '',
        logo: require('../assets/img/cny.svg')
      },
      KWD: {
        name: 'Kuwaiti Dinar',
        slug: 'kuwaiti-dinar',
        symbol: 'kwd',
        urls: {
          website: '#'
        },
        about: '',
        logo: require('../assets/img/kwd.svg')
      }
    },
    units: {
      ETB: {
        label: 'Ethiopian Birr',
        symbol: 'etb',
        logo: require('../assets/img/etb.svg')
      }
    },
    baseUnits: 'etb',
    graphOptions: {
      interval: '1d'
    },
    graphStats: {
      min: 0,
      max: 0
    }
  },
  getters: {
    topCurrencies: state => {
      return state.top.map(short => (({ about, logo, name, slug, symbol }) => ({ about, logo, name, slug, symbol }))(state.metas[short]))
    },
    getCurrencyBySlug: (state) => (slug) => {
      return state.metas[slugs[slug]] || {}
    },
    getTickerBySlug: (state) => (slug) => {
      const pair = slugs[slug].toLowerCase() + '' + state.baseUnits
      return state.tickers[pair] || {}
    },
    getInfoBySlug: (state) => (slug) => {
      const pair = slugs[slug].toLowerCase() + '' + state.baseUnits
      return state.infos[pair] || {}
    },
    getGraphStats: (state) => () => {
      return state.graphStats || {}
    }
  },
  mutations: {
    UPDATE_INFO: (state, payload) => {
      state.infos[payload.pair] = {
        ...state.infos[payload.pair],
        ...payload
      }
    },
    UPDATE_TICKER: (state, payload) => {
      state.tickers[payload.pair] = {
        ...state.tickers[payload.pair],
        ...payload
      }
    },
    UPDATE_GRAPH_OPTIONS: (state, payload) => {
      state.graphOptions = {
        ...state.graphOptions,
        ...payload
      }
    },
    UPDATE_GRAPH_STATS: (state, payload) => {
      state.graphStats = {
        ...state.graphStats,
        ...payload
      }
    }
  },
  actions: {},
  modules: {}
})
